import { type Environment } from '../types';

export const BFF_ENV_URL_MAP: Record<Environment, string> = {
  dev: 'https://search-bff.envdevel.com/',
  stage: 'https://search-bff.envstage.com/',
  prod: 'https://search-bff.engelvoelkers.com/',
} as const;

export const SEARCH_API_ENV_URL_MAP: Record<Environment, string> = {
  dev: 'https://search-api.envdevel.com/',
  stage: 'https://search-api.envstage.com/',
  prod: 'https://search-api.engelvoelkers.com/',
} as const;

export const AI_CHAT_BOT_ENV_URL_MAP: Record<Environment, string> = {
  dev: 'https://ai-chat-bot.envdevel.com/',
  stage: 'https://ai-chat-bot.envstage.com/',
  prod: 'https://ai-chat-bot.engelvoelkers.com/',
} as const;
